import { render, staticRenderFns } from "./checkbox-card.vue?vue&type=template&id=10a81a18&scoped=true"
import script from "./checkbox-card.vue?vue&type=script&lang=js"
export * from "./checkbox-card.vue?vue&type=script&lang=js"
import style0 from "./checkbox-card.vue?vue&type=style&index=0&id=10a81a18&prod&lang=scss&scoped=true"
import style1 from "./checkbox-card.vue?vue&type=style&index=1&id=10a81a18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@5.2.7_webpack@4.47.0___3aa45358577dd566fcc66441f4bfb966/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a81a18",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VCheckbox: require('/opt/atlassian/pipelines/agent/build/components/form/v-checkbox.vue').default,Card: require('/opt/atlassian/pipelines/agent/build/components/core/card.vue').default})
